export const Footer = () => {
  return (
    <footer className="bg-evergreen-light text-cream border-t border-cream/10" data-testid="footer">
      <div className="max-w-[1180px] mx-auto px-6 md:px-10 py-16">
        <div className="flex flex-col md:flex-row justify-between gap-10">
          <div>
            <div className="flex items-baseline gap-2">
              <span className="font-serif text-2xl tracking-tight text-cream">Columbus</span>
              <span className="font-mono text-[10px] tracking-[0.3em] uppercase text-gold-light">Home Options</span>
            </div>
            <p className="text-cream/60 text-sm mt-4 max-w-sm leading-relaxed">
              Helping Columbus, Georgia homeowners explore their selling options — with no pressure and no obligation.
            </p>
          </div>
          <div className="flex flex-col gap-3">
            <a href="tel:+14709088726" className="font-mono text-sm text-cream/80 hover:text-gold-light transition-colors">(470) 908-8726</a>
            <a href="#start" className="font-mono text-sm text-cream/80 hover:text-gold-light transition-colors">Get Started</a>
            <a href="#faq" className="font-mono text-sm text-cream/80 hover:text-gold-light transition-colors">FAQ</a>
            <a href="/admin" className="font-mono text-xs text-cream/40 hover:text-gold-light transition-colors mt-2">Admin</a>
          </div>
        </div>
        <div className="border-t border-cream/10 mt-12 pt-8">
          <p className="text-cream/40 text-xs leading-relaxed max-w-2xl">
            © 2026 Columbus Home Options. This website is for marketing and lead-generation purposes.
            We are not a real-estate brokerage and do not provide real-estate representation.
          </p>
        </div>
      </div>
    </footer>
  );
};
